export default "__VITE_ASSET__bIlZKfwg__"